module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_9016.c5e32119.png";